import { createQueryProvider } from '@/modules/auto-query-context'
import { useExpiringFans } from '@/modules/expiring-fans/query/expiring-fans-query'

export const { useExpiringFansQuery, ExpiringFansQueryProvider } =
  createQueryProvider('ExpiringFansQuery', useExpiringFans)
